import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { NavLink, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useNavigate } from 'react-router-dom';

import Loading from "../components/Loading";
import * as _ from "lodash";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  FormControl,
  FormControlLabel,
  Button,
  Checkbox,
  Alert,
  Box,
  Snackbar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
} from "@mui/material";
import { spacing } from "@mui/system";
import { connect } from "react-redux";
import axios from "../../CustomAxios";
import moment from "moment";
import { Download, FileDownload } from "@mui/icons-material";

const Card = styled(MuiCard)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function FormDetails({ audits, user, details, urls, auths }) {
  // console.log("user is", details);
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const status = ["new", "studio", "ctp_impose", "ctp", "delivery"];
  const [, setNextStatus] = useState("");
  const [success] = useState(false);
  const [err] = useState("");
  const snackRef = useRef(null);
  const navigate = useNavigate();
  const { job_id } = useParams();
  const [currentApCompany, setCurrentApCompany] = useState(details?.ap_company._id);
  const [apMachines, setApMachines] = useState([]);

  // eslint-disable-next-line
  const [loader, setLoader] = useState(false);

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, op } = state;
  const handleClick = (newState) => () => {
    setState({ op: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, op: false });
  };

  const downloadJobPdf = async (id, details) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      let url =
        process.env.NODE_ENV === "development"
          ? ""
          : process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;

      url += `/api/v1/${authData?.type}/jobs/${id}/generate_pdf`;
      fetch(url, {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
        method: "GET",
      }).then(async (res) => {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display:none";
        const file = await res.blob();
        const url = URL.createObjectURL(file);
        a.href = url;
        const jobName = details?.job_id;
        a.download = jobName + ".pdf";
        a.click();
        window.URL.revokeObjectURL(url);
        setLoader(false);
      });
    } catch (e) {
      setLoader(false);
      console.log(e);
    }
  };

  const getApMachines = async (companyId) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.get(`/api/v1/${userData.type}/machine/${companyId}`, config);
      if (data.success) {
        setApMachines(data.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (details?.ap_company) {
      getApMachines(details.ap_company._id);
    }
  }, [details?.ap_company?._id]);


  useEffect(() => {
    const current = details?.current_status;
    const ind = status.indexOf(current);
    if (ind < status.length && ind !== -1) {
      setNextStatus(status[ind + 1]);
    } else {
      setNextStatus(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details]);

  return (
    <>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={op}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity="error">
            {err}
          </Alert>
        ) : success ? (
          <Alert mt={2} mb={4} severity="success">
            Status Updated Successfully
          </Alert>
        ) : null}
      </Snackbar>

      {!loader ? (
        <form>
          <Card mb={6}>
            <CardContent>
              <Paper elevation={3} style={{ padding: "2%" }}>
                <Grid container spacing={5}>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography color="primary" variant="h6" gutterBottom>
                      Job Details{" "}
                      <Chip
                        label={details.current_status.toUpperCase()}
                        size="small"
                        color="primary"
                        sx={{ mb: 1 }}
                      />
                    </Typography>
                    <Box>
                      {(
                        auths?.user?.role?.permissions.includes('duplicate_jobs') ||
                        authData?.type === 'super_admin'
                      ) && <Button
                        variant="outlined"
                        onClick={() => {

                          navigate(`/dashboard/jobs/create-job/${job_id}`)
                        }}
                        // onClick={() => downloadJobPdf(details._id, details)}
                        // endIcon={<Download />}
                        sx={{ marginRight: "10px" }}
                        size="small"
                      >
                          Duplicate Job
                        </Button>}
                      <Button
                        variant="outlined"
                        onClick={() => downloadJobPdf(details._id, details)}
                        endIcon={<Download />}
                        size="small"
                      >
                        Job PDF
                      </Button>
                    </Box>
                  </Grid>
                  {/* Job Meta Data */}
                  <Grid item xs={12} md={4} lg={3}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Job Id"
                      value={details?.job_id}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={5}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Job Name"
                      value={details?.name}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    {user?.role?.permissions.includes("view_job_cost") ||
                      authData?.type === "super_admin" ? (
                      <TextField
                        type="text"
                        fullWidth
                        size="small"
                        label="Job Total Cost"
                        value={details?.job_total_cost}
                        inputProps={{ readOnly: true }}
                      />
                    ) : (
                      <TextField
                        type="text"
                        fullWidth
                        size="small"
                        label="Job Total Cost"
                        value={"Permission Denied"}
                        inputProps={{ readOnly: true }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Binding Style"
                      value={details?.binding_style}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>

                  {/* Customer Company Details */}
                  <Grid item xs={12} md={3} lg={3}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Customer Company"
                      value={details.customer_company?.name}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={5} lg={5}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Delivery"
                      value={
                        details.delivery
                          ? `${details.delivery?.address_line_one}, ${details.delivery?.address_line_two}, ${details.delivery?.city}, ${details.delivery?.state}, ${details.delivery?.pincode}, India`
                          : ""
                      }
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={2} lg={2}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Customer Company User"
                      value={details.customer_company_user?.name}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={2} lg={2}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Customer Contact Number"
                      value={details.customer_company_user.phone_number}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>

                  {/* AP Company Details */}
                  <Grid item xs={12} md={4} lg={3}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="AP Company"
                      value={details.ap_company?.name}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={3}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="AP Company User"
                      value={details.ap_company_user?.name}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={3}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="AP Contact Number"
                      value={details.ap_contact_number}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={3}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Docket By"
                      value={details?.docket_details?.action_by?.name}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>

                  {/* Job Details */}
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="PC-AP"
                      value={details?.pc_ap}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="number"
                      fullWidth
                      size="small"
                      label="Total Form"
                      value={details?.total_form}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Open-Height"
                      value={details?.open_height}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Open-Width"
                      value={details?.open_width}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Cut"
                      value={details?.cut}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="number"
                      fullWidth
                      size="small"
                      label="Page"
                      value={details?.page}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="number"
                      fullWidth
                      size="small"
                      label="F/B"
                      value={details?.fb}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="number"
                      fullWidth
                      size="small"
                      label="S/B"
                      value={details?.sb}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="number"
                      fullWidth
                      size="small"
                      label="D/G"
                      value={details?.dg}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="number"
                      fullWidth
                      size="small"
                      label="O/S"
                      value={details?.os}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Recieved Date"
                      value={new Date(details?.received_date).toLocaleString()}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={2}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Delivery Date"
                      value={new Date(details?.required_date).toLocaleString()}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4} lg={4}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Job Instructions"
                      value={details?.instructions}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={4}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Category"
                      value={
                        details.category !== null
                          ? details?.category
                          : ""
                      }
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={4}>
                    <TextField
                      type="text"
                      fullWidth
                      size="small"
                      label="Refer Job"
                      value={
                        details.referred_job !== null
                          ? details?.referred_job?.job_id +
                          " - " +
                          details?.referred_job?.name
                          : ""
                      }
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </CardContent>
          </Card>

          {/* Plate Details */}
          <Card mb={6}>
            <CardContent>
              <Paper elevation={3} style={{ padding: "2%" }}>
                <Grid container spacing={5}>
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography color="primary" variant="h6" gutterBottom>
                      Plate Details
                    </Typography>
                  </Grid>
                  {details?.plates?.map((pl) => {
                    return (
                      <>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="search-field"
                            value={pl?.plate_details?.company}
                            label="Company"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="search-field"
                            value={
                              pl?.machine_details
                                ? `${pl.machine_details.name || ''} - ${pl.machine_details.serial_no || ''}`
                                : 'No machine assigned'
                            }
                            label="AP Machine"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="search-field"
                            value={pl?.plate_details?.technology?.name}
                            label="Technology"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="search-field"
                            value={pl?.plate_details?.brand?.name}
                            label="Brand"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="search-field"
                            value={pl?.plate_details?.hsn}
                            label="hsn"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="search-field"
                            value={pl?.plate_details?.height}
                            label="Height"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="search-field"
                            value={pl?.plate_details?.width}
                            label="Width"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="search-field"
                            value={pl?.plate_details?.thickness}
                            label="Thickness"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="search-field"
                            type="number"
                            value={pl?.gripper}
                            label="Gripper"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            type="text"
                            id="search-field"
                            value={pl?.screen}
                            inputProps={{ readOnly: true }}
                            label="Screen + Paper"
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            type="number"
                            id="search-field"
                            inputProps={{ readOnly: true }}
                            value={pl?.set}
                            label="Set"
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            id="standard-number"
                            label="Bake Quantity"
                            fullWidth
                            size="small"
                            inputProps={{ readOnly: true }}
                            value={pl?.bake}
                            type="number"
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            id="standard-number"
                            label="Printout Quantity"
                            value={pl?.printout}
                            inputProps={{ readOnly: true }}
                            type="number"
                            fullWidth
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="standard-number"
                            label="ctp"
                            value={pl?.ctp_plate_count}
                            inputProps={{ readOnly: true }}
                            type="number"
                            m={2}
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="standard-number"
                            label="Total Quantity"
                            inputProps={{ readOnly: true }}
                            value={pl?.quantity}
                            type="number"
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={3}>
                          <FormControl
                            fullWidth
                            size="small"
                            component="fieldset"
                            variant="standard"
                          >
                            <FormControlLabel
                              control={
                                <Checkbox checked={pl.not_to_bill || false} />
                              }
                              label={"Not to Bill"}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} lg={3} md={3}>
                          <FormControl
                            fullWidth
                            component="fieldset"
                            variant="standard"
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={pl.production_rejection || false}
                                />
                              }
                              label={"Production-Rejection"}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} lg={9} md={6}></Grid>
                        <Grid item xs={12} lg={12} md={12}></Grid>
                      </>
                    );
                  })}
                </Grid>
              </Paper>
            </CardContent>
          </Card>

          {user?.role?.permissions.includes("view_job_audit_logs") ||
            authData?.type === "super_admin" ? (
            <Card mb={6}>
              <CardContent>
                <Paper elevation={3} style={{ padding: "2%" }}>
                  <Grid container spacing={5}>
                    <Grid item xs={12} md={12} lg={12}>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography color="primary" variant="h6" gutterBottom>
                            Audit Logs
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid item xs={12} md={12} lg={12}></Grid>
                          <Timeline position="alternate">
                            {audits &&
                              audits?.map((audit, ind) => {
                                return ind % 2 === 0 ? (
                                  <TimelineItem>
                                    <TimelineOppositeContent
                                      align="right"
                                      variant="body2"
                                      // color="secondary"

                                      color={
                                        audit?.audit_logs?.action_type ===
                                          "reverse"
                                          ? "tomato"
                                          : "secondary"
                                      }
                                    >
                                      <br />

                                      {moment(
                                        audit?.audit_logs?.timestamp
                                      ).format("MMM DD, YYYY hh:mm A")}
                                    </TimelineOppositeContent>
                                    <TimelineSeparator>
                                      <TimelineConnector />
                                      <TimelineDot
                                        color="primary"
                                        variant="outlined"
                                      ></TimelineDot>
                                      <TimelineConnector />
                                    </TimelineSeparator>
                                    <TimelineContent>
                                      <Typography
                                        variant="h6"
                                        component="span"
                                        color={
                                          audit?.audit_logs?.action_type ===
                                            "reverse"
                                            ? "tomato"
                                            : "inherit"
                                        }
                                      >
                                        {_.upperCase(audit?.audit_logs?.action)}
                                      </Typography>
                                      <Typography variant="body1">
                                        By-
                                        {audit?.audit_logs?.user_details
                                          ?.name || "Super Admin"}
                                      </Typography>
                                      <Typography variant="body2">
                                        {_.upperCase(
                                          audit?.audit_logs?.user_type
                                        ) || "SUPER ADMIN"}
                                      </Typography>
                                    </TimelineContent>
                                  </TimelineItem>
                                ) : (
                                  <TimelineItem>
                                    <TimelineOppositeContent
                                      variant="body2"
                                      // color="secondary"
                                      color={
                                        audit?.audit_logs?.action_type ===
                                          "reverse"
                                          ? "tomato"
                                          : "secondary"
                                      }
                                    >
                                      <br />

                                      {moment(
                                        audit?.audit_logs?.timestamp
                                      ).format("MMM DD, YYYY hh:mm A")}
                                    </TimelineOppositeContent>
                                    <TimelineSeparator>
                                      <TimelineConnector />
                                      <TimelineDot color="primary"></TimelineDot>
                                      <TimelineConnector />
                                    </TimelineSeparator>
                                    <TimelineContent>
                                      <Typography
                                        variant="h6"
                                        component="span"
                                        color={
                                          audit?.audit_logs?.action_type ===
                                            "reverse"
                                            ? "tomato"
                                            : "inherit"
                                        }
                                      >
                                        {_.upperCase(audit?.audit_logs?.action)}
                                      </Typography>
                                      <Typography variant="body1">
                                        By-{" "}
                                        {audit?.audit_logs?.user_details
                                          ?.name || "Super Admin"}
                                      </Typography>
                                      <Typography variant="body2">
                                        {_.upperCase(
                                          audit?.audit_logs?.user_type
                                        ) || "SUPER ADMIN"}
                                      </Typography>
                                    </TimelineContent>
                                  </TimelineItem>
                                );
                              })}
                          </Timeline>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  </Grid>
                </Paper>
              </CardContent>
            </Card>
          ) : null}

          <Card mb={6}>
            <CardContent>
              <Paper elevation={3} style={{ padding: "2%" }}>
                <Grid container spacing={5}>
                  <Grid item xs={12} md={12} lg={12}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography color="primary" variant="h6" gutterBottom>
                          Studio Images
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid item xs={12} md={12} lg={12}></Grid>
                        <Timeline>
                          {urls &&
                            urls?.map((url) => {
                              return (
                                <TimelineItem>
                                  <TimelineOppositeContent
                                    align="left"
                                    variant="body2"
                                    color="secondary"
                                    style={{
                                      maxWidth: "10%",
                                    }}
                                  >
                                    <br />
                                    <br />
                                    {_.upperCase(url.stage)}
                                  </TimelineOppositeContent>
                                  <TimelineSeparator>
                                    <TimelineConnector />
                                    <TimelineDot
                                      color="primary"
                                      variant="outlined"
                                    ></TimelineDot>
                                    <TimelineConnector />
                                  </TimelineSeparator>
                                  <TimelineContent>
                                    <Paper
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                      }}
                                      mt={3}
                                    >
                                      <Box
                                        component="img"
                                        width="90px"
                                        height="80px"
                                        // onClick={() =>
                                        //   handleOpen(
                                        //     urls[i]?.url,
                                        //     urls[i]?.type
                                        //   )
                                        // }
                                        src={
                                          url?.type === "pdf"
                                            ? "/static/img/images/pdf.png"
                                            : url?.url
                                        }
                                        style={{ cursor: "pointer" }}
                                      />
                                      <TextField
                                        fullWidth
                                        margin="dense"
                                        m={2}
                                        style={{
                                          marginLeft: 32,
                                          width: "100%",
                                        }}
                                        inputProps={{ readOnly: true }}
                                        id="standard-required"
                                        label="Document Name"
                                        value={url?.name || ""}
                                      />
                                      <Grid item>
                                        <a
                                          href={url?.url}
                                          style={{
                                            color: "inherit",
                                            textDecoration: "inherit",
                                          }}
                                          download={`${url.name}.${url?.type}`}
                                        >
                                          <FileDownload
                                            style={{
                                              marginLeft: 32,
                                              cursor: "pointer",
                                            }}
                                          />
                                        </a>
                                      </Grid>
                                    </Paper>
                                  </TimelineContent>
                                </TimelineItem>
                              );
                            })}
                        </Timeline>
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                </Grid>
              </Paper>
            </CardContent>
          </Card>
        </form>
      ) : (
        <Loading />
      )}
    </>
  );
}

const getJobDetails = async (id, company, setState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData?.access_token,
      },
    };
    let url = "";
    if (authData?.type === "customer_user") {
      url = `/api/v1/${authData?.type}/${company}/jobs/${id}`;
    } else {
      url = `/api/v1/${authData?.type}/jobs/${id}`;
    }
    const { data } = await axios.get(url, config);
    if (data.success) {
      setState((prev) => {
        return { ...prev, Details: data.data };
      });
    }

    let auditUrl = "";
    if (authData?.type === "customer_user") {
      auditUrl = `/api/v1/${authData?.type}/${company}/jobs/${id}/audit_logs`;
    } else {
      auditUrl = `/api/v1/${authData?.type}/jobs/${id}/audit_logs`;
    }
    const audit = await axios.get(auditUrl, config);
    if (audit.data.success) {
      setState((prev) => {
        return { ...prev, audits: audit.data.data, loader: false };
      });
    }
    const apUser = await axios.get(
      `/api/v1/${authData?.type}/ap_user?company_id=${data.data.ap_company._id}`,
      config
    );
    if (apUser.data.success) {
      setState((prev) => {
        return { ...prev, apUser: apUser.data.data.data, loader: false };
      });
    }

    const studio = await axios.get(
      `/api/v1/${authData?.type}/jobs/${id}/studio_images`,
      config
    );
    if (studio.data.success) {
      setLinks(studio.data.data, setState);
    } else {
      setState((prev) => {
        return { ...prev, loader: false };
      });
    }
  } catch (e) {
    setState((prev) => {
      return { ...prev, loader: false };
    });
  }
};

const setLinks = (document, setMyState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let urls = [];
    // eslint-disable-next-line
    document.map((doc) => {
      const type =
        doc?.studio_images?.document_storage_info?.key?.split(".")[1];
      urls.push({
        url: `/api/v1/${authData?.type}/media/${doc.studio_images.document_storage_info.key}`,
        name: doc.studio_images.document_title,
        type: type,
        key: doc?.studio_images.document_storage_info?.key,
        stage: doc.studio_images.document_upload_stage,
      });
    });
    sendRequests(urls, setMyState);
  } catch (e) {
    console.log(e);
  }
};

const sendRequests = async (urls, setMyState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let num = urls.length;
    if (num === 0) {
      setMyState((prev) => {
        return { ...prev, loader: false };
      });
    }
    let n = 0;
    let allUrls = [];
    // eslint-disable-next-line
    urls.map((l) => {
      let PROD_URL = "";
      if (process.env.NODE_ENV === "development") {
        PROD_URL = process.env.REACT_APP_BACKEND_DEV_API_URL;
      } else {
        PROD_URL = process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;
      }
      fetch(PROD_URL + l.url, {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
        method: "GET",
      })
        .then(async (resp) => {
          return resp.arrayBuffer();
        })
        .then(async (res) => {
          n++;
          if (l.type === "pdf") {
            const myFile = new Blob([res], { type: "application/pdf" });
            const url = URL.createObjectURL(myFile);
            allUrls.push({
              url: url,
              name: l.name,
              type: l.type,
              key: l.key,
              stage: l.stage,
            });
          } else {
            const myFile = new Blob([res], { type: "image/png" });
            const url = URL.createObjectURL(myFile);
            allUrls.push({
              url: url,
              name: l.name,
              type: l.type,
              key: l.key,
              stage: l.stage,
            });
          }
          if (n === num) {
            setMyState((prev) => {
              return { ...prev, urls: allUrls, loader: false };
            });
          }
        });
    });

    // setLoader(false);
  } catch (e) {
    setMyState((prev) => {
      return { ...prev, loader: false };
    });
    console.log(e);
  }
};

function JobDetails({ auths }) {
  const { job_id } = useParams();
  const [state, setState] = useState({
    Details: {},
    audits: [],
    loader: true,
    apUser: [],
    user: [],
    up: 0,
    urls: [],
  });

  useEffect(() => {
    if (auths?.user) {
      setState({ ...state, user: auths?.user });
    }
    const id = auths?.user?.customer_company?._id;
    getJobDetails(job_id, id, setState);
    // eslint-disable-next-line
  }, [auths.user, state.up, job_id]);

  if (!state.loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              JOB DETAILS{" "}
              <span style={{ color: "#a9a9a9" }}>
                [{state.Details.job_id} | {state.Details.customer_company.name}]
              </span>
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/jobs">
                All Jobs
              </Link>
              <Typography>Job Details</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* <GeneralDetails /> */}
            <FormDetails
              up={state.up}
              setSt={setState}
              audits={state.audits}
              user={state.user}
              details={state.Details}
              apUser={state.apUser}
              urls={state.urls}
              auths={auths}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(JobDetails);
